var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommunicationRfsPagingTower = function SvgCommunicationRfsPagingTower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.97,
    cy: 12.089,
    r: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6464DB",
    fillRule: "evenodd",
    d: "m11.847 7.33 2.608 2.076-.242-.611-2.366-1.893zM9.97 20.089h.73l1.147-13.187v-.44h-.635z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6464DB",
    fillRule: "evenodd",
    d: "m11.532 9.957 3.146 2.467-.085-.595-3.013-2.368z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6464DB",
    fillRule: "evenodd",
    d: "M15.97 20.089h-.73L14.093 6.902v-.44h.635z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6464DB",
    fillRule: "evenodd",
    d: "m11.316 12.77 3.715 3.044-.077-.681-3.638-2.947z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6464DB",
    d: "M11.7 4.089h2.513v2.78H11.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#6464DB",
    fillRule: "evenodd",
    d: "m11.003 16.242 4.28 3.388-.073-.647-4.12-3.278zM14.176 7.33l-2.608 2.076.243-.611 2.365-1.893zM14.399 9.957l-3.146 2.467.085-.595 3.013-2.368z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6464DB",
    fillRule: "evenodd",
    d: "m14.752 12.77-3.715 3.044.077-.681 3.638-2.947zM15.004 16.242l-4.28 3.388.072-.647 4.121-3.278z",
    clipRule: "evenodd"
  })));
};
export default SvgCommunicationRfsPagingTower;